import { IntEnumConditions, StringConditions } from '../../../../grid/gridFilters/types';

export interface PackageSecurityServerAssignmentGridWebComponentSchema {
  gridData: Array<SchemaSVA>;
  dropdownData: Array<SchemaSVA>;
  useEncryption: boolean;
}

export interface PackageSecurityServerAssignmentGridSchema {
  data: Array<SchemaSVA>;
}

export enum PackageSVAEvent {
  OnDeleteSVA = 'deleteSVA',
  MoveUpSVA = 'moveUpSVA',
  MoveDownSVA = 'moveDownSVA',
}

export interface SchemaSVA {
  _id: string;
  protectedEntityId: string;
  name: string;
  type: number;
  ip: string;
  customHostname: string;
}

export enum Column {
  PRIORITY,
  NAME,
  IP,
  CUSTOM_HOST,
  ACTIONS,
}

export enum ColumnKeys {
  PRIORITY = 'priority',
  NAME = 'name',
  IP = 'ip',
  CUSTOM_HOST = 'customHostname',
  ACTIONS = 'actions',
}

export interface DataGridItem {
  _id: string;
  protectedEntityId: string;
  priority?: number;
  name: string;
  ip: string;
  actions?: string;
  customHostname?: string;
}

export interface SetFiltersRequest {
  viewId: string;
  filters: Array<Filter>;
}

export interface Filter {
  priority?: IntEnumConditions;
  name?: StringConditions;
}

export interface DataGridItemsResponse {
  rawEvents: Array<DataGridItem>;
  success: boolean;
}

export const COLUMNS = [0, 1, 2, 3, 4];
